import { render, staticRenderFns } from "./AppFormCardCollapsable.vue?vue&type=template&id=5b60d56e&scoped=true&"
import script from "./AppFormCardCollapsable.vue?vue&type=script&lang=js&"
export * from "./AppFormCardCollapsable.vue?vue&type=script&lang=js&"
import style0 from "./AppFormCardCollapsable.vue?vue&type=style&index=0&id=5b60d56e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b60d56e",
  null
  
)

export default component.exports